import { render } from "./authority.vue?vue&type=template&id=60791332&scoped=true"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"

import "./authority.vue?vue&type=style&index=0&id=60791332&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60791332"]])

export default __exports__